import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.scss";

import ProviderAlerta from "./contexts/ContextAlert";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom/client";
import Router from "./router";
import React from "react";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <ProviderAlerta>
            <Router />
        </ProviderAlerta>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
